import React from 'react';
import PropTypes from 'prop-types';
import { without } from 'lodash';
import classNames from 'classnames';
import Svg from 'rp-react-svg-icon';

import NavLink from './components/NavLink';
import HelpLink from './components/HelpLink';
import MoreBtn from './components/MoreBtn';
import SubNav from './components/SubNav';
import tabNames, { sireSubTabs } from './helpers/tabNames';
import isShown from './helpers/isShown';
import calculateTabUrl from './helpers/calculateTabUrl';
import checkSubTabSelected from './helpers/checkSubTabSelected';
import calculateActiveClass from './helpers/calculateActiveClass';


const Nav = ({
                 params: { type, id, name, tab: currentTab, hash = '', mr = {} },
                 helpUrl, tabsToExclude, horseType, isMobile,
                 onSubnavMenuExpand, isSubnavMenuExpanded, userRole, pageName,
             }) => {
    const url = `${type}/${id}/${name}`;
    // removing tabs that shouldn't be rendered
    const tabs = without(tabNames[horseType || type], ...tabsToExclude);

    // calculating on what sreen size we need a "More" button
    const MoreBtnIsShown = tabs.length > (isShown.XN + 1);
    const MoreBtnIsShownOnNarrow = tabs.length > (isShown.N + 1);

    // sire tabs has sub-tabs so we need to handle this case
    const isSire = horseType === 'sire';
    const hasWeatherbys = isSire && !tabsToExclude.includes('stallionDetails');

    const isSubTabSelected = isSire && checkSubTabSelected(currentTab);
    const activeClassName = calculateActiveClass(
        isSire, hasWeatherbys, isSubTabSelected, currentTab,
    );

    const currentSubTab = currentTab ||
    (hasWeatherbys ? 'weatherbys-overview' : 'progeny');

    return (
        <nav
            className={classNames(
                'ui-tabs__wrapper',
                isSubTabSelected && 'pp-tabs__subNavWrapper'
            )}
        >
            <div className="ui-tabs pp-tabs dark">
                {tabs.map((tabName, index) => (
                    <NavLink
                        url={url}
                        hash={hash}
                        key={tabName}
                        tabName={tabName}
                        userRole={userRole}
                        pageName={pageName}
                        tabUrl={calculateTabUrl(
                            currentTab,
                            tabName,
                            index,
                            isSire,
                            mr.isShown,
                        )}
                        activeClassName={activeClassName}
                        cssClasses={[
                            MoreBtnIsShown && index >= isShown.XN && 'hidden-xs-down',
                            MoreBtnIsShownOnNarrow && index >= isShown.N && 'hidden-sm-down',
                        ]}
                    />
                ))}
                {MoreBtnIsShown &&
                <MoreBtn
                    url={url}
                    hash={hash}
                    tabNames={tabs.slice(isShown.XN)}
                    currentTab={currentTab}
                    is5Tabs={tabs.length === 5}
                />
                }
                <HelpLink url={helpUrl} />
            </div>
            {
                sireSubTabs.stallionDetails.includes(currentSubTab) &&
                hasWeatherbys &&
                (
                    <div className="stallion-logo">
                        <Svg
                            iconName="stallionBookLogo"
                        />
                    </div>
                )}
            {isSubTabSelected &&
            <SubNav
                currentTab={currentTab}
                hasWeatherbys={hasWeatherbys}
                url={url}
                isMobile={isMobile}
                isExpanded={isSubnavMenuExpanded}
                onSubnavMenuExpand={onSubnavMenuExpand}
            />
            }
        </nav>
    );
};

Nav.defaultProps = {
    tabsToExclude: [],
};

Nav.propTypes = {
    params: PropTypes.shape({
        type: PropTypes.string,
        id: PropTypes.string,
        name: PropTypes.string,
        tab: PropTypes.string,
        hash: PropTypes.string,
        subTab: PropTypes.string,
        mr: PropTypes.shape({
            isShown: PropTypes.bool,
        }),
    }),
    helpUrl: PropTypes.string.isRequired,
    tabsToExclude: PropTypes.arrayOf(
        PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
    ),
    horseType: PropTypes.string,
    isMobile: PropTypes.bool,
    onSubnavMenuExpand: PropTypes.func,
    isSubnavMenuExpanded: PropTypes.bool,
    userRole: PropTypes.string.isRequired,
    pageName: PropTypes.string.isRequired,
};

export default Nav;



// WEBPACK FOOTER //
// ./src/js/shared/nav/Nav.jsx